/**
 * スポット入札 (通常・ブロック) の承認ステータスを定期再取得する間隔 (30 秒)。
 *
 * spec AC-BSP-096 (`docs/specs/bidding/spot-bidding.md`): スポット入札画面を表示中
 * は一定間隔で承認状態バナー (AC-BSP-067) の承認ステータスを自動再取得し、他ユーザー
 * の操作 (承認者の承認・差戻し、AC-BSP-094) を手動リロードなしで反映する。間隔値・
 * 実装方式は EN 判断範囲 (同 AC の注記)。
 *
 * 30 秒に決めた根拠 (issue #6316):
 *
 * - 同じ承認ドメインの先行実装が 30 秒で揃っている: ワークフロー一覧・詳細
 *   (AC-WFW-039 / `hooks/workflowCase/refetchInterval.ts` の
 *   `WORKFLOW_CASE_REFETCH_INTERVAL_MS`) と承認案件一覧 (`useListApprovalTasks`)。
 *   AC-BSP-096 は AC-WFW-039 と同じ「申請者・承認者 2 名の連携動作のリードタイム」
 *   を理由に採択された AC なので、同じ間隔を使う。
 * - 同一画面に 5 秒ポーリング (`HISTORY_REFETCH_INTERVAL_MS`) の先行実装があるが、
 *   あれは JEPX への送信状態・約定という市場データ軸の値。承認の受け渡しは分単位の
 *   業務であり (spec AC-WFW-039 の判断根拠と同じ)、加えて本間隔は受渡日フィルタ無し
 *   の全受渡日一覧 (AC-BSP-095 の他日承認待ちバナー用) にも掛かるため、5 秒では
 *   取得量に見合わない。
 *
 * 掛かるのは通常入札・ブロック入札の**承認依頼一覧**だけで、承認依頼の明細 Get は
 * 定期再取得しない (spec が編集中データの巻き込みを避けるため対象を承認ステータスに
 * 限定している)。明細は一覧が承認状態の変化を拾った時だけ 1 回取り直す
 * (`pages/SpotBidding/models/approvalDetailSync.ts`)。
 */
export const APPROVAL_STATE_REFETCH_INTERVAL_MS = 30 * 1000
